<template>
    <div>
        <div style="margin-left: 20px;">
            <el-table :data="tableData" row-key="id" border size="mini">
                <el-table-column prop="typeName" label="类型"></el-table-column>
                <el-table-column prop="value" label="值"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="deleteRow(scope.$index, tableData)"
                            type="text"
                            size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table> 
            <el-button
                icon="el-icon-circle-plus-outline"
                type="text"
                @click="add"
            >
                添加规则
            </el-button> 
        </div>
        <el-form-item label="编码样例">
            <el-input :value="example" placeholder="请输入编码样例" readonly />
        </el-form-item>
        <el-dialog
            :visible="visible"
            :beforeClose="close"
        >
            <el-form
                ref="form"
                :model="formData"
                :rules="rules"
                size="small"
                label-width="100px"
            >
                <el-form-item
                    label="类型"
                    prop="type"
                >
                    <el-select v-model="formData.type" placeholder="请选择类型">
                        <el-option label="固定值" value="fixed"></el-option>
                        <el-option label="日期" value="date"></el-option>
                        <el-option label="序号" value="serial"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="值"
                    prop="value"
                >
                    <el-input v-model="formData.value" placeholder="请输入" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="confirm">确定</el-button>
                <el-button @click="close">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Sortable from 'sortablejs'
import { copy } from '@/utils/tools'
const transType = value => {
    switch (value) {
        case 'fixed' : {
            return '固定值'
        }
        case 'date' : {
            return '日期'
        }
        case 'serial' : {
            return '序号'
        }
    }
}
export default {
    props: {
        ruleList: {
            type: Array,
            default: () => [
                {
                    id: '1',
                    type: 'fixed',
                    typeName: '固定值',
                    value: 'SD'
                },
                {
                    id: '2',
                    type: 'date',
                    typeName: '日期',
                    value: 'yyMMdd'
                },
                {
                    id: '3',
                    type: 'serial',
                    typeName: '序号',
                    value: '3'
                }
            ]
        }
    },
    data() {
        return {
            tableData: copy(this.ruleList),
            visible: false,
            rules: {
                type: [
                    {
                        required: true,
                        message: '请选择类型',
                        trigger: 'blur',
                    }
                ],
                value: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur',
                    }
                ]
            },
            formData: {
                type: '',
                value: ''
            }
        }
    },
    computed: {
        example() {
            return this.tableData.reduce((acc, cur) => acc + cur.value, '')
        }
    },
    watch: {
        tableData: {
            handler(value) {
                const ruleList = value.map((item, index) => {
                    item.sort = index
                    return item
                })
                this.$emit('codeRules', {
                    ruleList,
                    example: this.example
                })
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        deleteRow(index, rows) {
            rows.splice(index, 1);
            // 重置id
            rows.map((row, index) => {
                row.id = index
            })
        },
        // 行拖拽
        rowDrop() {
            // 要侦听拖拽响应的DOM对象（数据存储在.el-table__body-wrapper > .el-table__row > tbody标签中（el-table的数据部分的“最外层”class名为el-table__body-wrapper））
            const tbody = document.querySelector('.el-table__body-wrapper tbody')
            const _this = this
            Sortable.create(tbody, {
                // 结束拖拽后的回调函数
                onEnd({ newIndex, oldIndex }) {
                    console.log('拖动了行，序号(index)"'+oldIndex+'"拖动到序号(index)"' + newIndex+'"')
                    const currentRow = _this.tableData.splice(oldIndex, 1)[0] // 将oldIndex位置的数据删除并取出，oldIndex后面位置的数据会依次前移一位
                    _this.tableData.splice(newIndex, 0, currentRow) // 将被删除元素插入到新位置（currRow表示上面的被删除数据）
                }
            })
        },
        add() {
            this.visible = true
        },
        confirm() {
            this.$refs.form.validate(valid => {
                if(valid) {
                    if(this.tableData.length >= 5) {
                        this.$message.warning('最多可以添加5条规则')
                    } else {
                        const { type, value } = this.formData
                        this.tableData.push({
                            id: this.tableData.length + 1,
                            type,
                            typeName: transType(type),
                            value
                        })
                        this.close()
                    }
                }
            })
        },
        close() {
            this.formData = { type:'', value: '' }
            this.visible = false
        }
    },
    mounted() {
        this.rowDrop()
    }
}
</script>